import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	container: {
		backgroundColor: theme.palette.neutral[5],
		borderRadius: theme.borderRadius.rounded,
		padding: theme.spacing.xsmall,
	},
	star: {
		color: theme.palette.green[120],
	},
	bolt: {
		color: theme.palette.yellow[100],
	},
	checkmark: {
		color: theme.palette.semantic.green[100],
	},
	brand: {
		color: theme.primary.color.default,
	},
	goldAward: {
		color: theme.award.foregroundColor.gold,
	},
	silverAward: {
		color: theme.award.foregroundColor.silver,
	},
}));
